import { Project, ProjectInvitation, Quote, User } from '@/generated/api';

export function shouldDisableRFQActions(
  rfq: Project,
  invitation?: ProjectInvitation,
  user?: User | null,
): boolean {
  return (
    invitation?.status === ProjectInvitation.status.REJECTED ||
    invitation?.status === ProjectInvitation.status.TIMED_OUT ||
    rfq?.status === Project.status.CLOSED ||
    !checkIsUserInTenderArea(rfq, user)
  );
}

export function checkIsUserInTenderArea(
  rfq?: Project,
  user?: User | null,
): boolean {
  if (!!rfq && (!rfq.tenderArea || rfq.tenderArea.length === 0)) return true;
  if (user === null) return true; // access via token
  if (!!rfq && rfq.companyId === user?.company.id) return true;
  if (!!rfq && rfq.tenderArea?.includes(user?.company?.address?.country || ''))
    return true;

  return false;
}

export function shouldShowQuoteReviewButton(quote?: Quote | null): boolean {
  return !!quote && !!quote.positions && quote.positions.length > 0;
}
